<script>
import App from "@/pages/layouts/app.vue";
import Card from "@/pages/components/card.vue";
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import {Link, router} from "@inertiajs/vue3";
import Menu from "@/pages/customers/_menu.vue";
import TablePlugin from "@wielink/datatables";
import DefaultRenderers from "@wielink/datatables/Renderers/DefaultRenderers";
import CustomerProductActionsRenderer from "@jntestapparatuur/customer-management/js/CustomerProductActionsRenderer";

export default {
  mixins: [Datatable],
  components: {Menu, Link, App, Card},
  props: ['customer'],

  methods: {
    initialiseDatatable() {
      new TablePlugin({
        scope: this.$refs.table.$refs.table,
        renderers: {...DefaultRenderers, 'customer_product_actions_renderer': CustomerProductActionsRenderer}
      });

      $(document).off('.showclick').on('click.showclick', '[data-dt-btn="show"]', (event) => {
        event.preventDefault();
        let url = $(event.currentTarget).attr('href');
        router.get(url);
      })
    }
  },
}
</script>

<template>
  <App title="Producten">
    <Menu :customer-id="customer.id"/>

    <template #topButtons>
      <Link :href="route('customers.products.create', {'customer': customer})" class="btn btn-primary">
        <i class="bi bi-link-45deg"></i>
        Product koppelen
      </Link>
    </template>

    <Card>
      <Table ref="table" id="customer_products" :config="tableConfig"/>
    </Card>
  </App>
</template>